import { combineReducers } from 'redux';

import * as ActionType from '../constants/constant_action_types';
import * as SagaType from '../constants/constant_saga_types.js';

const TABLE_DATA_INIT_STATE = {
  data: [],
  rows_per_page: null,
  requested_page: 1,
  page: 1,
  total_rows: 0,
  is_fetching: false,
  error: '',
  sorted_columns: {
    created_datetime: {
      direction: 'asc'
    },
  },
  id: null,
};

const inventoryReducer = function(state = TABLE_DATA_INIT_STATE, action) {
  switch (action.type) {
    case ActionType.SET_SALE_TRANSACTION_INVENTORY: {
      const { payload = {} } = action;
      return {
        ...state,
        ...payload,
        page: payload.requested_page || state.page,
        total_rows: payload.total || state.total_rows,
        is_fetching: false,
      };
    }
    case SagaType.FETCH_SALE_TRANSACTION_INVENTORY:
      const { payload } = action;
      return {
        ...state,
        is_fetching: true,
        page: payload.requested_page,
      };
    default:
      return state;
  }
};

export const saleTransactionReducer = combineReducers({
  inventory: inventoryReducer
});
